// extracted by mini-css-extract-plugin
export default {"bouncingLoader":"BouncingDots_bouncingLoader__IxKn7","bouncing-loader":"BouncingDots_bouncing-loader__K5leq"};